<!--
 * @Author: 方宾菲
 * @Date: 2025-02-12 11:34:50
 * @LastEditors: 方宾菲
 * @LastEditTime: 2025-02-12 11:34:55
 * @Description: 
 * @FilePath: \ys.gnss\src\components\xtgl\sgjdpz\components\formSet\svg-icon\index.vue
-->
<template>
    <svg
        :class="svgClass"
        aria-hidden="true"
    >
        <use :xlink:href="iconName"></use>
        <title v-if="!!title">{{ title }}</title>
    </svg>
</template>

<script>
export default {
    name: 'SvgIcon',
    props: {
        iconClass: {
            type: String,
            required: true
        },
        className: {
            type: String
        },
        title: {
            type: String,
            default: ''
        }
    },
    computed: {
        iconName() {
            return `#icon-${this.iconClass}`
        },
        svgClass() {
            if (this.className) {
                return 'svg-icon ' + this.className
            } else {
                return 'svg-icon'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.svg-icon {
    width: 1.1em;
    height: 1.1em;
    margin-left: 0.35em;
    margin-right: 0.35em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    display: inline-block;
}
</style>